import React, {Component} from 'react';
import FieldGroups from "../FieldGroups";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";

class QueryGroups extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	getQueryGroups() {
		let fieldGroups = this.props.endpoint.displayData[this.props.currentItem].filters.filter(el => {
			return el.name === 'meta_group';
		});

		return fieldGroups.map(el => el.fields[0].value);
	}

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const {addSubField, group} = this.props;

		const newQueryGroup = {
			name:   'queryGroup',
			label:  'Group',
			fields: [
				{
					id:          'groupName',
					inputType:   'input',
					sourceName:  'name',
					sourceValue: 'value',
					value:       '',
					label:       'Group name',
					dynamic:     false
				}, {
					id:           'relation',
					inputType:    'select',
					source:       'relationTypes',
					sourceName:   'name',
					sourceValue:  'value',
					value:        '',
					label:        'Relation',
					defaultValue: 'Select a field type',
					dynamic:      false
				},
			],
		};

		return (<React.Fragment>

			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (
					<React.Fragment>
							<h3>Query Groups ({endpoint.displayData[currentItem].queryGroups.length})</h3>

							<p>Query Groups are used for grouping meta fields, so you can have nested query levels.</p>

							<button className="button-secondary" onClick={() => addSubField(endpointId, [ newQueryGroup ], currentItem, group, action)}>
								Add a group
							</button>

							<FieldGroups group={group}/>
					</React.Fragment>
				)}
				</FieldGroupContext.Consumer>
			</React.Fragment>);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(QueryGroups);
